import axios from "../../config/axiosConfig";
import { GENERAL_SETTING_REQUEST, SET_GENERAL_SETTING, GENERAL_SETTING_REQUEST_FAILURE, SET_RELOAD_SETTINGS_PAYLOAD } from "../types";

export const getGeneralSetting = (makeLoaded) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_SETTING_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id }; //Need to discuss

      return axios.get("/general-setting/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: SET_GENERAL_SETTING, payload: response.data });
        }
        if (makeLoaded) {
          dispatch({ type: SET_RELOAD_SETTINGS_PAYLOAD, payload: {
                isLoaded: true,
                lastFetchedAt: Date.now()
              }
          })
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_SETTING_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_SETTING_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const saveGeneralSetting = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: GENERAL_SETTING_REQUEST });

      return axios.put("/general-setting/save", { id, data }, 
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
          if (response.data) {
            dispatch({ type: SET_GENERAL_SETTING, payload: response.data });
          } else {
            dispatch({
              type: GENERAL_SETTING_REQUEST_FAILURE,
              error: "Save general setting failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: GENERAL_SETTING_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_SETTING_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getScheduleLockByModules = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };

      return axios.get("/schedule-lock-by-module/get", { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const saveScheduleLockByModules = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.customer?.id, companyId: auth.company?.id, userId: auth.user?.id };

      return axios.post("/schedule-lock-by-module/save", { data }, { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getScheduleLockByModuleName = (moduleName) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id, moduleName };

      return axios.get("/schedule-lock-by-module/get-by-module", { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getMailSmtpSettingModules = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };

      return axios.get("/mail-smtp-setting/get", { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const saveMailSmtpSettingModules = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.customer?.id, companyId: auth.company?.id, userId: auth.user?.id };

      return axios.post("/mail-smtp-setting/save", { data }, { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getMailSmtpSettingModuleName = (moduleName) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id, moduleName };

      return axios.get("/mail-smtp-setting/get-by-module", { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const setResetLoadSettingsOption = () => {
    return async (dispatch) => {
        dispatch({ type: SET_RELOAD_SETTINGS_PAYLOAD, payload: { isLoaded: false } });
    }
}